import React, {type ReactNode} from 'react';

import {apiV2ActionsBar} from './tab-actions-bar.module.styl';


type Props = {
    children: ReactNode,
};

export const TabActionsBar = ({children}: Props) => (
    <div className={apiV2ActionsBar}>
        {children}
    </div>
);
